import React from "react";
import NavBar from "./components/NavBar";

const Header = () => {
  return (
    <header className="site-header" role="banner">
      <div className="header-contents">
        <NavBar />
      </div>
    </header>
  );
};

export default Header;
